import {
  createRouter,
  createWebHistory,
  NavigationGuardNext,
  RouteLocationNormalized,
  RouteLocationNormalizedLoaded,
  RouteRecordRaw
} from 'vue-router'
import { setBaiduTrack, setLoading } from '@/utils'
import Common from '@/views/common.vue'
import store from '@/store'

const routes: Array<RouteRecordRaw> = [
  /**************************************** B端页面 ****************************************/
  /* 人客服务工作台 */
  {
    path: '/rkhy/workbench',
    name: 'workbench',
    component: () => import('@/views/workbench/Workbench.vue'),
    meta: { keepAliveName: 'Workbench' }
  },
  /* 人客服务工作台-全部待处理订单 */
  {
    path: '/rkhy/workbench/todo-order-list',
    name: 'workbenchTodoOrderList',
    component: () =>
      import('@/views/workbench/todo-order-list/TodoOrderList.vue'),
    meta: { keepAliveName: 'TodoOrderList' }
  },
  /* 人客服务分享赚页 */
  {
    path: '/share-earn',
    name: 'shareEarn',
    component: () => import('@/views/share-earn/ShareEarn.vue'),
    meta: { keepAliveName: 'ShareEarn' }
  },
  /* 人客与企微的云客服务分享页 */
  {
    path: '/share-service',
    name: 'shareService',
    component: () => import('@/views/share-service/ShareService.vue'),
    meta: { keepAliveName: 'ShareService' }
  },
  /* 人客与企微的云客服务分享任务列表页 */
  {
    path: '/share-service/task-list',
    name: 'shareServiceTaskList',
    component: () => import('@/views/share-service/task-list/TaskList.vue'),
    meta: { keepAliveName: 'TaskList' }
  },
  /* 人客与企微的云客服务分享任务详情页 */
  {
    path: '/share-service/task/:taskId',
    name: 'shareServiceTaskDetail',
    component: () => import('@/views/share-service/task-detail/TaskDetail.vue'),
    meta: { keepAliveName: 'TaskDetail' }
  },
  /* 人客与企微的云客服务分享商品素材列表页 */
  {
    path: '/share-service/material-list',
    name: 'shareServiceMaterialList',
    component: () =>
      import('@/views/share-service/material-list/MaterialList.vue'),
    meta: { keepAliveName: 'MaterialList' }
  },
  /* 错误提示页 */
  {
    path: '/tip',
    name: 'tip',
    component: () => import('@/views/tip/Tip.vue'),
    meta: { keepAliveName: 'Tip' }
  },
  /* 企微登录页（无用） */
  {
    path: '/workchat-login',
    name: 'workchatLogin',
    component: () => import('@/views/workchat-login/WorkchatLogin.vue'),
    meta: { keepAliveName: 'WorkchatLogin' }
  },
  /* 企微建群页 */
  {
    path: '/group-create',
    name: 'groupCreate',
    component: () => import('@/views/group-create/GroupCreate.vue'),
    meta: { keepAliveName: 'CreateGroup' }
  },
  /* 企微建群页 */
  {
    path: '/group-material',
    name: 'groupMaterial',
    component: () => import('@/views/group-material/GroupMaterial.vue'),
    meta: { keepAliveName: 'GroupMatetial' }
  },

  /**************************************** C端页面 ****************************************/
  {
    path: '/photography',
    name: 'photography',
    component: () => import('@/views/photography/Photography.vue'),
    meta: { keepAliveName: 'Photography' }
  },
  /* 图片全屏预览页 */
  {
    path: '/fullscreen-preview',
    name: 'fullscreenPreview',
    component: () => import('@/views/fullscreen-preview/FullscreenPreview.vue'),
    meta: { keepAliveName: 'FullscreenPreview' }
  },
  /* x元购活动详情页 */
  {
    path: '/xbuy-event/:eventId',
    name: 'xbuyEvent',
    component: () => import('@/views/xbuy-event/XBuyEvent.vue'),
    meta: { keepAliveName: 'XBuyEvent' }
  },
  /* 门票商详 */
  {
    path: '/ticket',
    component: Common,
    children: [
      {
        path: 'detail/:spuId',
        name: 'TicketDetail',
        component: () => import('@/views/ticket/index.vue'),
        meta: { childKeepAlive: true }
      },
      {
        path: 'introduce',
        name: 'TicketIntroduce',
        component: () => import('@/views/ticket/introduce/index.vue')
      }
    ]
  },
  /* 频道页 */
  {
    path: '/channel',
    name: 'channel',
    component: () => import('@/views/channel/Channel.vue'),
    meta: { keepAliveName: 'Channel' }
  },
  /* 同城亲子首页 */
  {
    path: '/local-kids',
    name: 'local-kids',
    component: () => import('@/views/local-kids/Home.vue'),
    meta: { keepAliveName: 'LocalKids' }
  },
  {
    path: '/local-kids/rank',
    name: 'rank',
    component: () => import('@/views/local-kids/Rank.vue'),
    meta: { keepAliveName: 'Rank' }
  },
  /* 天天特卖 */
  {
    path: '/day_promotion',
    name: 'day_promotion',
    component: () => import('@/views/promotion/DayPromotion.vue')
  },
  /* 福袋首页 */
  {
    path: '/lucky-bag/home',
    name: 'lucky-bag',
    component: () => import('@/views/lucky-bag/LuckyBag.vue')
  },
  /* 定制游需求表单 */
  {
    path: '/travel-configure/:setId',
    name: 'travelConfigure',
    component: () => import('@/views/travel-configure/TravelConfigure.vue')
  },
  /* 定制游需求表单提交成功 */
  {
    path: '/travel-configure/success',
    name: 'travelConfigureSuccess',
    component: () =>
      import('@/views/travel-configure/success/TravelConfigureSuccess.vue')
  },
  /* 教育品类权益卡 */
  {
    path: '/education-card/detail/:spuId',
    name: 'education-card',
    component: () => import('@/views/education-card/EducationCard.vue')
  },
  /* 研学详情 */
  {
    path: '/education-tourism/detail/:spuId',
    name: 'education-tourism',
    component: () => import('@/views/education-tourism/EducationTourism.vue')
  },
  /* 研学相册 */
  {
    path: '/education-tourism/album',
    name: 'education-tourism-album',
    component: () => import('@/views/education-tourism/AlbumDetail.vue')
  },
  /* 用户领券（盟军虚拟券） */
  {
    path: '/get-coupon',
    name: 'get-coupon',
    component: () => import('@/views/get-coupon/index.vue')
  },
  /* 城市广告获客宝广告计划表单 */
  {
    path: '/ad-plan-form',
    name: 'adPlanForm',
    component: () => import('@/views/ad-plan-form/AdPlanForm.vue'),
    meta: { keepAliveName: 'adPlanForm' }
  }
]

const scrollBehavior = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalizedLoaded,
  savedPosition: any
) => {
  if (!from.name) {
    return {
      left: 0,
      top: 0
    }
  }
  if (savedPosition) {
    return savedPosition
  }
}

const router = createRouter({
  history: createWebHistory('v2'),
  scrollBehavior,
  routes
})

router.beforeEach(
  (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext
  ) => {
    if (Object.keys(to.query).indexOf('_debug') > -1 || import.meta.env.DEV) {
      import('vconsole').then(v => {
        new v.default()
      })
    }
    const keepAliveName = <string>to.meta.keepAliveName
    const keepAliveRoutes = store.state.keepAliveRoutes
    if (keepAliveName && keepAliveRoutes.indexOf(keepAliveName) === -1) {
      store.commit('setKeepAliveRoutes', keepAliveRoutes.concat(keepAliveName))
    }
    setLoading()
    next()
  }
)

router.afterEach(() => {
  setBaiduTrack()
  setLoading(false)
})

export default router
